import { Directive, HostListener, ElementRef, OnInit, HostBinding, Input, Optional, Self } from "@angular/core";
import { NgControl } from "@angular/forms";
import { CultureService } from "@tymes4-shared";

@Directive({
    selector: "[currencyformat]",
    standalone: false
})
export class CurrencyFormatterDirective implements OnInit {

  @Input() currencyformat: number | string = 2;
  @Input() displayCurrencyCode: boolean = true;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private cultureService: CultureService,
    @Optional() @Self() private ngControl: NgControl
  ) {
    this.el = this.elementRef.nativeElement;
    // Currency formatting requires type="text" not type="number"
    if (this.el.type === 'number') {
      this.el.type = 'text';
    }
  }

  get fractionSize(): number {
    return typeof this.currencyformat === 'number' ? this.currencyformat : parseInt(this.currencyformat) || 2;
  }

  // A bare `currencyformat` attribute binds '', which in currency mode means: use the culture's decimals.
  private get decimals(): number | undefined {
    if (!this.displayCurrencyCode) {
      return this.fractionSize;
    }

    const parsed = typeof this.currencyformat === 'number' ? this.currencyformat : parseInt(this.currencyformat);
    return isNaN(parsed) ? undefined : parsed;
  }

  ngOnInit() {
    if (this.el.value) {
      this.el.value = this.formatValue(this.el.value);
    }
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.cultureService.parseCurrency(value, this.decimals);
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    this.updateControlValue(value);
    this.el.value = this.formatValue(value);
  }

  // NumberValueAccessor parses the locale text with parseFloat ("13,75" -> 13), so push the culture-parsed number
  private updateControlValue(value: string) {
    if (!this.ngControl?.control || value === null || value === undefined || value === '') {
      return;
    }

    const numericValue = this.cultureService.toNumber(value);
    if (isNaN(numericValue)) {
      return;
    }

    this.ngControl.control.setValue(numericValue, { emitModelToViewChange: false });
    this.ngControl.viewToModelUpdate(numericValue);
  }

  private formatValue(value: any): string {
    if (this.displayCurrencyCode) {
      return this.cultureService.formatCurrency(value, this.decimals);
    } else {
      return this.cultureService.formatNumber(value, this.fractionSize);
    }
  }
}
